//@flow

// Vendors
import React from 'react';
import { useDispatch } from 'react-redux';

// Components
import { Modal, Content } from '../..';
import PaymentFrame, {
  PaymentFrameTypes,
} from '../../../Payment/PaymentFrame/PaymentFrame';

// Actions
import { getPaymentAccounts } from '../../../../reducers/payment/paymentActions';
import { closeModal } from '../../../../reducers/modal/modalActions';

import './add-payment-account-modal.scss';

const AddPaymentAccountModal = () => {
  const dispatch = useDispatch();

  const handleSuccess = () => {
    dispatch(getPaymentAccounts());
    dispatch(closeModal('AddPaymentAccountModal'));
  };

  return (
    <Modal
      name="AddPaymentAccountModal"
      className="add-payment-account-modal"
      disableOnClickOutside="true"
    >
      <h2 className="h1 modal-title">
        <Content type="Payment" id="AddCardTitle" />
      </h2>
      <p className="lead">
        <Content type="Payment" id="AddCardDescription" />
      </p>
      <PaymentFrame
        type={PaymentFrameTypes.ADD_ACCOUNT}
        onSuccess={handleSuccess}
        onCancel={() => dispatch(closeModal('AddPaymentAccountModal'))}
      />
    </Modal>
  );
};

export default AddPaymentAccountModal;
